import type { DetectionRangeOption } from "src/modules/asset/components/asset-detail/asset-configuration/components/types";

export const clampValue = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

const getDefaultMotionRangeLabel = (value: number | null) => {
  switch (value) {
    case 1:
      return "Level 1";
    case 2:
      return "Level 2";
    case 3:
      return "Level 3";
    case 4:
      return "Level 4";
    case 5:
      return "Level 5";
    case 6:
      return "Level 6";
    case 7:
      return "Level 7";
    case 8:
      return "Level 8";
    case 9:
      return "Level 9";
    case 10:
      return "Level 10";
    default:
      return null;
  }
};

export const getMotionRangeLabel = (
  value: number | null,
  options: DetectionRangeOption[] = [],
) => {
  const option = options.find((opt) => opt.id === value);
  return option?.name || getDefaultMotionRangeLabel(value);
};

export const formatOperationModeName = (name: string | null) => {
  return name ? name?.replace(/_/g, " ") : "";
};
